import React, { useContext, useState, useEffect } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { navigate } from '@reach/router';
import AppStateContext from '../../../context/appStateContext';

import Card from '../customerCard';
import { ListCtn, Overflow, Spacer, SubmitBtn, SubmitBtnDisable } from './index.style';

interface CardProps {
  customerList: { BillTo: string; CustomerCode: string; CustomerName: string; TerritoryCode: any }[];
}

const CustomerList: React.FC<CardProps> = ({ customerList}): React.ReactElement => {
  const { setAppPageDetails, selectedCustomerId } = useContext(AppStateContext);
  const [ buttonVisible, setButtonVisible ] = useState(false);

  const getCurrentCards = () => {
    return customerList.map(customer => (
      <Card
        key={customer.CustomerCode}
        BillTo={customer.BillTo}
        CustomerCode={customer.CustomerCode}
        CustomerName={customer.CustomerName}
        TerritoryCode={customer.TerritoryCode}
      />));
  };

  const submit = () => {
    setAppPageDetails('home');
    navigate('/app/home');
  };

  useEffect(() => {
    if(selectedCustomerId) {
      setButtonVisible(true);
    }
  }, [selectedCustomerId]);

  return (
    <React.Fragment>
      <Overflow>
        <ListCtn>{getCurrentCards()}</ListCtn>
      </Overflow>

      {buttonVisible ? (
        <SubmitBtn
          type="button"
          onClick={(e): void => {
            e.preventDefault();
            submit();
          }}
        >
          GET STARTED
        </SubmitBtn>
      ) : (
        <SubmitBtnDisable
          type="button"
          onClick={(e): void => {
            e.preventDefault();
            submit();
          }}
          disabled
        >
          GET STARTED
        </SubmitBtnDisable>
      )}
      <Spacer />
    </React.Fragment>
  );
};

export default CustomerList;
